<span *ngIf="timer$ | async as timer">{{ timer.days ?? 0 }}d {{ timer.hours ?? 0 }}h {{ timer.minutes ?? 0 }}m</span>
